import { render, staticRenderFns } from "./PrivacyNoticeContent.vue?vue&type=template&id=74544765&"
import script from "./PrivacyNoticeContent.vue?vue&type=script&lang=js&"
export * from "./PrivacyNoticeContent.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyNoticeContent.vue?vue&type=style&index=0&id=74544765&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports